import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

/** What the user-info dialog asks for. */
export enum UserInfoDialogMode {
  NAME_AND_ROLE = 'name_and_role',
  LEGAL_AGREEMENTS = 'legal_agreements',
  NAME_AND_ROLE_AND_LEGAL_AGREEMENTS = 'name_and_role_and_legal_agreements',
}

export const USER_INFO_DIALOG_HEADERS: Record<
  UserInfoDialogMode,
  { title: string; subtitle: string }
> = {
  [UserInfoDialogMode.NAME_AND_ROLE]: {
    title: _('Welcome!'),
    subtitle: _("Let's set up your profile"),
  },
  [UserInfoDialogMode.LEGAL_AGREEMENTS]: {
    title: _('Update to our Terms and Privacy Policy'),
    subtitle: _(
      "We've updated our Terms of Service and Privacy Policy. Please review and accept to continue.",
    ),
  },
  [UserInfoDialogMode.NAME_AND_ROLE_AND_LEGAL_AGREEMENTS]: {
    title: _('Welcome!'),
    subtitle: _("Let's set up your profile and review our Terms of Service and Privacy Policy"),
  },
};
